import { IconCalendarMonth, IconChartBar, IconCopy, IconHandClick, IconPencil, IconQrcode, IconTrash } from '@tabler/icons-react'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { toast } from 'sonner'
import { getApi, postApi } from '../../api/call.api'
import { urlApi } from '../../api/url.api'
import IconButton from '../../components/Buttons/IconButton'
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal'
import TableComponent from '../../components/DataTable/TableComponent'
import DateRange from '../../components/DateRange/DateRange'
import DropDown from '../../components/DropDown/DropDown'
import Pagination from '../../components/Pagination/Pagination'
import DateFilterInfoPopup from '../../components/Popover/DateFilterInfoPopup'
import SearchComponent from '../../components/Search/SearchComponent'
import Layout from '../../layout/Layout'
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller'
import { dateIntoYYYY_MM_DD, formatDateToShortMonthDayYear } from '../../utils/dateTimeConverter'
import LinkShareModal from '../Links/Components/LinkShareModal'
import BusinessCardQrViewModal from './Components/BusinessCardQrViewModal'
import CreateBusinessCardLinkModal from './Components/CreateBusinessCardLinkModal'
import BusinessCardTablePreview from './Components/PageTemplates/BusinessCardTablePreview'
import { accessCheck } from '../../utils/accessCheck'
import { accessKeys } from '../../statics/accessKeys'

const DigitalCard = () => {
    const sortingFilterList = [
        {
            id: null,
            name: "All"
        }, {
            id: 1,
            name: "Scan H-L",
            value: 'linkClicks,DESC'
        }, {
            id: 2,
            name: "Scan L-H",
            value: 'linkClicks,ASC'
        }
    ]
    const [activePage, setActivePage] = useState(1);
    const [perPage, setPerPage] = useState(4);
    const [searchData, setSearchData] = useState('');
    const [date, setDate] = useState({ startDate: '', endDate: '' });
    const [sortFilter, setSortFilter] = useState(null);
    const [tableData, setTableData] = useState({
        data: [],
        totalCount: 0
    });
    const [loadingState, setLoadingState] = useState(false);
    const [analyticsCardsData, setAnalyticsCardsData] = useState({})

    function handlePageChange(page) {
        setActivePage(page);
    }

    function handlePerRowsChange(newPerPage, page) {
        setActivePage(page);
        setPerPage(newPerPage)
    }

    async function getList() {
        loadingShow();
        let sortingFilterLocal = sortingFilterList?.find(item => item?.name == sortFilter)
        let postData = {
            "startDate": dateIntoYYYY_MM_DD(date.startDate),
            "endDate": dateIntoYYYY_MM_DD(date.endDate)
        }
        let url = `${urlApi.getBusinessCardList}?page=${activePage}&limit=${perPage}`;
        if (searchData) {
            url += "&search=" + searchData
        }
        if (sortingFilterLocal?.id) {
            url += `&sort=${sortingFilterLocal ? sortingFilterLocal?.value : null}`
        }
        let resp = await postApi((postData?.startDate ? postData : {}), url);
        loadingHide();
        if (resp.responseCode === 200) {
            setTableData({
                data: resp.data.items,
                totalCount: resp.data.count
            });
        } else {
            setTableData({
                data: [],
                totalCount: 0
            });
        }
    }

    async function getCardData() {
        setLoadingState(true);
        let resp = await getApi(urlApi.getAnalyticsCardsData);
        setLoadingState(false);
        if (resp.responseCode === 200) {
            setAnalyticsCardsData(resp.data);
        } else {
            setAnalyticsCardsData({});
        }
    }

    function onDateChange(p) {
        let newDate = { startDate: p.startDate._d, endDate: p.endDate._d }
        setActivePage(1);
        setDate(newDate)
    }

    function onSortingFilterChange(sort) {
        setActivePage(1)
        setSortFilter(sort)
    }

    useEffect(() => {
        if (accessCheck(accessKeys?.viewBusinessCardList)) {
            getList();
        }
        if (accessCheck(accessKeys?.viewBusinessCardAnalyticsCard)) {
            getCardData();
        }
        return () => {
        };
    }, [activePage, searchData, date, sortFilter]);

    function onCopy(copyText) {
        navigator.clipboard
            .writeText(copyText)
            .then(() => {
                toast.success("Link copied");
            })
            .catch(() => {
                toast.error("something went wrong");
            });
    }

    async function deleteLink(linkId) {
        loadingShow();
        let resp = await getApi(urlApi.deleteCard + linkId);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            reset();
        } else {
            toast.error(resp.message);
        }
    }

    async function publishPage(pageId) {
        let resp = await getApi(urlApi.publishBusinessCard + pageId);
        if (resp.responseCode === 200) {
            getList();
            toast.success(resp.message);
        } else {
            toast.error(resp.message);
        }
    }

    function reset() {
        setActivePage(1);
        setSearchData('');
        setDate({ startDate: '', endDate: '' });
        setSortFilter(null);
    }

    const columns = [
        {
            name: "", selector: (row) => row?.channel_name, grow: 3, cell: (row) => (
                <div className='flex py-2 gap-3 items-center'>
                    <div className=''>
                        <BusinessCardTablePreview pageData={row?.businessCardDesign} blocksData={[row?.businessCardProfile]} />
                    </div>
                    <div className="text-left">
                        <p className="mb-0.5 font-semibold text-sm text-[var(--black)]">{row?.linkName}</p>
                        <Link to={row?.shortLink} target='_blank'> <p className="mb-0.5 font-semibold text-primary text-sm">{row?.shortLink}</p></Link>
                        <Link to={row?.mainLink} target='_blank'><p className="mb-0.5 text-xs italic text-[var(--black)]">{row?.mainLink}</p></Link>
                        <div className="flex gap-2 flex-wrap">
                            <p className={`font-semibold text-[10px] ${row?.linkClicks > 0 ? 'text-green-500' : 'text-[#BDBDBD]'} inline-flex items-center gap-1 mb-0`}> <span> <IconChartBar size={16} /> </span> {row?.linkClicks ?? "0"} engagements</p>
                            <p className={`font-semibold text-[10px] ${row?.uniqueLinkClicks > 0 ? 'text-green-500' : 'text-[#BDBDBD]'} inline-flex items-center gap-1 mb-0`}> <span> <IconHandClick size={16} /> </span> {row?.uniqueLinkClicks ?? "0"} unique clicks</p>
                            <p className="font-semibold text-[10px] text-[#BDBDBD] inline-flex items-center gap-1 mb-0"> <span> <IconCalendarMonth size={16} /> </span> {formatDateToShortMonthDayYear(row?.createdAt)}</p>
                        </div>
                    </div>
                </div>
            )
        }, {
            name: "", center: "true", grow: 0.5, selector: (row) => row?.qrLink, omit: !accessCheck(accessKeys?.createBusinessCardQr), cell: (row) => (<>{row?.qrLink ? <BusinessCardQrViewModal qrLink={row?.qrLink} /> : <Link to={'/create-business-card-qr'} state={{ data: row?.shortLink, linkId: row?.linkId }} className='primary-btn'>Create QR</Link>}</>)
        }, {
            name: "", center: "true", grow: 1.2, selector: (row) => row?.category, cell: (row) => (
                <div className="flex gap-2 items-center flex-wrap justify-center">
                    <IconButton icon={< IconCopy size={16} />} text={"Copy"} onClickFunction={() => onCopy(row?.shortLink)} />
                    <LinkShareModal type={'Business Card'} shareUrl={row?.shortLink} />
                    {accessCheck(accessKeys?.viewBusinessCardDetails) && <Link to={"/business-card-details"} state={row} className='no-underline'>  <IconButton icon={< IconChartBar size={16} />} text={"Details"} /></Link>}
                    {accessCheck(accessKeys?.createAndEditBusinessCard) && <Link to={"/create-business-cards/" + row?.linkId}> <IconButton icon={< IconPencil size={16} />} /></Link>}
                    {(accessCheck(accessKeys?.publishBusinessCard) && row?.publishStatus == 2) && <ConfirmationModal
                        buttonComponent={<IconButton icon={<IconHandClick size={16} color='white' />} text={"Publish Now"} cssClass={'primary-btn'} />}
                        confirmationText={"Are You Sure Want To Publish This Card?"}
                        onConfirm={() => publishPage(row?.linkId)}
                    />}
                    {accessCheck(accessKeys?.deleteBusinessCard) && <ConfirmationModal buttonComponent={<IconButton icon={<IconTrash size={16} />} />} confirmationText={"Are You Sure Want To Delete This Card?"}
                        onConfirm={() => deleteLink(row?._id)}
                    />}
                </div>
            )
        }
    ];
    return (
        <Layout>
            <div className='flex mb-2 items-center justify-between flex-wrap'>
                <p className='text-[17px] font-bold text-[var(--grey)] px-2'>Digital Business Card</p>
                {accessCheck(accessKeys?.createAndEditBusinessCard) && <CreateBusinessCardLinkModal />}
            </div>
            {accessCheck(accessKeys?.viewBusinessCardAnalyticsCard) && <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
                <StatsCard title={"Total Scans"} loadingState={loadingState} value={analyticsCardsData?.totalScans || '0'} colorCode={'text-[#144EE3]'} accentColor={'bg-[#144EE310]'} />
                <StatsCard title={"Current Month Scans"} loadingState={loadingState} value={analyticsCardsData?.currentMonthScans || '0'} colorCode={'text-[#43E5A0]'} accentColor={'bg-[#43E5A010]'} />
                <StatsCard title={"Active Digital Business Card"} loadingState={loadingState} value={analyticsCardsData?.activeCards || '0'} colorCode={'text-[#FBBC05]'} accentColor={'bg-[#FBBC0510]'} />
                <StatsCard title={"Active Dynamic QR Code"} loadingState={loadingState} value={analyticsCardsData?.activeQrCodes || '0'} colorCode={'text-[#EB568E]'} accentColor={'bg-[#EB568E1A]'} />
            </div>}

            <p className='text-[17px] font-bold mb-2 text-[var(--grey)] px-2'>Digital Cards</p>

            <div className="flex mb-3 items-center gap-3 flex-wrap">
                <SearchComponent onClear={() => { document.getElementById("link-table-search").value = ""; setSearchData('') }} inputValue={searchData}
                    onSearch={() => { setSearchData(document.getElementById("link-table-search")?.value); setActivePage(1) }} inputId='link-table-search' placeholder={"Search business cards..."} />
                <DateRange onApplyClick={(date) => onDateChange(date)} date={date} cssClass={'ms-auto'} />
                {date?.startDate && <DateFilterInfoPopup />}
                <DropDown title={"Sort By"} list={sortingFilterList?.map(item => item?.name)} defaultValue={sortFilter} onSelect={(name) => onSortingFilterChange(name)} />
            </div>
            <TableComponent
                columns={columns}
                data={tableData.data}
                totalRows={tableData.totalCount}
                isPagination={false}
                paginationPerPage={perPage}
                handlePageChange={(e) => handlePageChange(e)}
                handlePerRowsChange={(newPerPage, page) => handlePerRowsChange(newPerPage, page)} />

            <Pagination itemsPerPage={perPage} totalCount={tableData.totalCount} pageChangeFunction={(pageNum) => handlePageChange(pageNum)} currentPage={activePage} />
        </Layout>
    )
}

export default DigitalCard

export const StatsCard = ({ title, value, colorCode, accentColor, loadingState }) => {
    return (
        <div className={`${accentColor} py-3 px-5 rounded-lg`}>
            <IconQrcode className={colorCode} />
            {loadingState ? <div className={`animate-pulse ${accentColor} rounded-lg w-[100%] h-[38px]`}></div> : <p className={`mb-0 text-[25px] font-bold text-[var(--black)]`}>{value}</p>}
            <p className={`mb-0 text-[12px] font-semibold ${colorCode}`}>{title}</p>

        </div>
    )
}